import React from 'react';
import './style.scss'; //Import your CSS file
import businessImage from '../../assets/images/our_process.webp';
import {useTranslation} from "react-i18next";

const BusinessModule = () => {
    const {t} = useTranslation();
    return (
        <div id="business" className="business">
            <div className="container">
                <div className="grid grid-cols-2 gap-100">
                    <div className="business__left">
                        <img
                            src={businessImage}
                            alt="About Us"
                        />
                    </div>
                    <div className="business__right text-container">
                        <h2>{t('businessModule.title')}</h2>
                        <p style={{marginTop: '2.5%', textAlign: 'left'}}><b>{t('businessModule.description')}</b></p>
                        <div className="business__right__paragraph-content text-container">
                            <h3>{t('businessModule.heading1')}</h3>
                            <p>{t('businessModule.paragraph1')}</p>
                            <h3>{t('businessModule.heading2')}</h3>
                            <p>{t('businessModule.paragraph2')}</p>
                            <h3>{t('businessModule.heading3')}</h3>
                            <p>{t('businessModule.paragraph3')}</p>
                            <h3>{t('businessModule.heading4')}</h3>
                            <p>{t('businessModule.paragraph4')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessModule;
